exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-6049ff1c] {\n  padding: 2rem;\n}\n.right-aside[data-v-6049ff1c] {\n  padding: 0 20px 10px 20px;\n  width: 100%;\n  max-width: 100%;\n}\n.right-aside .content-header > h1[data-v-6049ff1c] {\n  margin: 2px;\n  padding-left: 13px;\n  padding-top: 12px;\n  font-size: 20px;\n  line-height: 1.5;\n}\n.right-aside .content-header[data-v-6049ff1c] {\n  /* margin: -2px -20px 25px -20px; */\n  height: 55px;\n  background: #f9fafb;\n  box-shadow: 3px 1px 5px #ccc;\n}\n", ""]);

// exports
